export default "__VITE_ASSET__vxyh4D_J__"